import React from 'react';
import { Button, InsightsIcon } from 'tuui';
import { TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useSimulatorButton } from './useSimulatorButton';
import styles from './simulatorButton.module.scss';

export const SimulatorButton = ({ campaignId, accountId, className, monitorId, ...props }) => {
    const { shouldRender, handleClick } = useSimulatorButton({ campaignId, accountId, monitorId });

    if (!shouldRender) {
        return null;
    }

    return (
        <div className={styles['button-wrapper']}>
            <Button
                onClick={handleClick}
                aria-label="Open simulator"
                variant={Button.variant.outline}
                size={Button.size.md}
                className={className}
                {...props}
            >
                <div className={styles['button-content']}>
                    <InsightsIcon className={styles['simulator-icon']} />
                    <FormattedMessage
                        id="app.campaigns.campaignsReports.header.simulator.label"
                        defaultMessage="Open simulator"
                    />
                </div>
            </Button>
            <Tooltip position={TOOLTIP_POSITION.BOTTOM} arrow>
                <FormattedMessage
                    id="app.campaigns.reports.grid.column.header.tooltip.campaign.simulator"
                    defaultMessage="Use the Performance simulator to explore, adjust and improve your campaign's performance"
                />
            </Tooltip>
        </div>
    );
};
